import { apiServiceInstance } from '@/core/helpers/utils';
import {
  ApiResponse,
  IApiRoleItem,
  PaginationResponseBase,
} from '@/core/interfaces/ApiResponses';

export default class RoleService {
  static list(): Promise<{
    data: ApiResponse<PaginationResponseBase<IApiRoleItem> | IApiRoleItem[]>;
  }> {
    return apiServiceInstance().vueInstance.axios.get(
      '/api/v1/roles/danh-sach',
      {
        params: {
          per_page: 1000,
        },
      }
    );
  }

  static get(id: number) {
    return apiServiceInstance().vueInstance.axios.get(
      `/api/v1/roles/chi-tiet${id}`
    );
  }
}
